import { SwiperProps } from 'swiper/react';
import Link from 'components/gruenland/atoms/link';
import Slider from 'components/gruenland/atoms/slider/Slider';
import ProductTile from 'components/gruenland/molecules/product-tile/ProductTile';
import { useFormat } from 'helpers/hooks/useFormat';
import { Product } from 'types/entity/product';
import { LineItem, Wishlist } from 'types/entity/wishlist';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';
import { Container } from 'components/gruenland/atoms/container/Container';

interface Props extends Partial<SwiperProps> {
  products: Product[];
  wishlist?: Wishlist;
  slidesPerView?: number;
  disableProductWishlistButton?: boolean;
  onProductClick?: (product: Product) => void;
  classNames?: {
    title?: string;
  };
  variant?: 'normal' | 'cart';
  addToWishlist?: (lineItem: LineItem, count: number) => Promise<void>;
  removeLineItem?: (item: LineItem) => Promise<void>;
}

const ProductSliderFullwidth: React.FC<Props> = ({
  products,
  wishlist,
  disableProductWishlistButton = false,
  addToWishlist,
  removeLineItem,
  onProductClick,
  spaceBetween = 8,
  ...props
}) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [isTabletSize] = useMediaQuery(tablet);
  return (
    <div className="px-6 md:px-0">
      <Slider
        slidesPerView={1}
        slidesPerGroup={1}
        dots={!isTabletSize}
        arrows
        arrowsPosition="inside"
        allowTouchMove
        spaceBetween={spaceBetween as number}
        {...props}
      >
        {products.map((product) => (
          <div key={product.productId} className="md:px-[100px]">
            <ProductTile
              variant="fullWidthSlider"
              wishlist={wishlist}
              disableWishlistButton={disableProductWishlistButton}
              product={product}
              cta={
                <Link link={product._url} variant="buttonPrimaryBlack" className="hidden md:flex">
                  {formatMessage({ id: 'tile.buyNow', defaultMessage: 'Acquista ora' })}
                </Link>
              }
              onClick={() => {
                onProductClick?.(product);
              }}
              addToWishlist={addToWishlist}
              removeLineItem={removeLineItem}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProductSliderFullwidth;
